import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FlashService } from './flash.service';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
    
    constructor(private http: HttpClient, private flashService: FlashService) { }

    GetPage(id) {
        return this.http.get('/api/Home/DashboardPage/?dashbordId=' + id).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    GetDashboard(id) {
        return this.http.get('/api/Home/DashboardGrid?id=' + id).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    private handleSuccess(res) {
        return { success: true, data: res };
    }

    private handleError(res) {
        this.flashService.Error(res.error.errors.toString(), false);
        return { success: false };
    }
}
